import React from "react";
import { useState, useEffect } from "react";
import { apiRevGeocodeLocationGoogle } from "utils/API/TrxNowAPI";
import { devLog } from "utils/devLog";

export default function TrxNowGeoLocation(props) {
  const [getCoordsErrorCount, setGetCoordsErrorCount] = useState(0);

  const getCoords = () => {
    if (navigator.geolocation) {
      devLog("GeoLocation Available");
      navigator.geolocation.getCurrentPosition(locationSuccess, locationError, {
        enableHighAccuracy: true,
        timeout: 2000,
        maximumAge: 0,
      });
    } else {
      devLog("GeoLocation not available");
      this.locationError({ code: 1 });
    }
  };

  // successfully got location
  const locationSuccess = (pos) => {
    devLog("Success Callback Called");
    const coords = pos.coords;
    devLog("Your current position is:");
    devLog(`Latitude : ${coords.latitude}`);
    devLog(`Longitude: ${coords.longitude}`);
    devLog(`More or less ${coords.accuracy} meters.`);
    apiRevGeocodeLocationGoogle({ lat: coords.latitude, lng: coords.longitude }, (addressResult) => {
      devLog("Address Result:", addressResult);

      if (typeof props.onLocationUpdate === "function") {
        props.onLocationUpdate({
          coords: {
            lat: coords.latitude,
            lng: coords.longitude,
          },
          address: addressResult,
        });
      }
    });
  };

  // if an error occurs, we'll keep trying up to 10 times to get the coords
  // a user can always enter their own value
  const locationError = (error) => {
    devLog("Error getting coords:", error);

    if (error.code === 1) {
      if (typeof props.onUserDeniedLocation === "function") {
        props.onUserDeniedLocation();
      }
      return;
    }

    setGetCoordsErrorCount(getCoordsErrorCount + 1);
    if (getCoordsErrorCount + 1 < 10) {
      // we might get a timeout error, try and call it again until it works
      setTimeout(() => {
        getCoords();
      }, 250);
    }
  };

  useEffect(() => {
    getCoords();
  }, []);

  return <></>;
}
